import { createAction, createReducer } from "@reduxjs/toolkit";
import { updateAdminStudio } from "./update-admin-studio";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = {
  processing: "idle",
};

export const resetUpdateAdminStudio = createAction("admin/studio/resetUpdate");

export const updateAdminStudioReducer = createReducer(initialState, builder => {
  builder
    .addCase(updateAdminStudio.pending, state => {
      state.processing = "pending";
    })
    .addCase(updateAdminStudio.fulfilled, state => {
      state.processing = "success";
    })
    .addCase(updateAdminStudio.rejected, state => {
      state.processing = "failed";
    })
    .addCase(resetUpdateAdminStudio, () => {
      return initialState;
    });
});
